export default __webpack_public_path__ + "static/banner_back-224f3cd3e57613cb319cffe470be212b.webp";